import { useSelector } from "react-redux";
import useMultiNotification from "../../hooks/useNotification";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
import ChatSidebar from "./ChatSideBar";
import ChatWindow from "./ChatWindow";
import "./chat.css";
export default function ChatApp() {
  const { contextHolder, openNotification } = useMultiNotification();
  const dispatch = useAppDispatch();

  const { error, isSubmitting } = useSelector((state: RootState) => state.chat);
  const { userProfile } = useSelector((state: RootState) => state.auth);
  // useEffect(() => {
  //   if (userProfile) {
  //     socket.emit(
  //       "join",
  //       {
  //         userId: userProfile.id,
  //         client: "web",
  //       },
  //       () => {}
  //     );
  //   }
  // }, [userProfile]);

  return (
    <div className="chat-container">
      <ChatSidebar />
      <ChatWindow />
    </div>
  );
}
